/** @format */

import { TRoom } from '@/@ducks/room/declarations';
import { utilityGetRoomPictures } from '@/@ducks/shared/helpers/getRoomPictures';

interface utilityGetRoomPicturesProps {
  media: TRoom['media'];
}

const useCardGallery = ({ media }: utilityGetRoomPicturesProps) => {
  const mediaFormatted = media;
  const { photosLowQuality, photosHighQuality, urlVR, hasVR, hasPlanimetry, urlPlanimetry, hasMultiplePhotos } =
    utilityGetRoomPictures({
      media: mediaFormatted,
    });

  return {
    photosLowQuality,
    photosHighQuality,
    urlVR,
    hasVR,
    hasMultiplePhotos,
    hasPlanimetry,
    urlPlanimetry,
  };
};

export default useCardGallery;
